define('SizeChart.Model', [
    'Backbone',
    'underscore',
    'Utils'
], function SizeChartModel(
    Backbone,
    _
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: _.getAbsoluteUrl(getExtensionAssetsPath('SizeChart/services/SizeChart.Service.ss')) // eslint-disable-line no-undef
    });
});
